export default (values) => {
  const errors = {}
  if (!values.unitName) errors.unitName = true
  if (!values.companiesIds) errors.companiesIds = true
  return errors
}
